module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/sprite-main/speaker-on-65cabac30972a85cdd4c92159752dacb.svg";